import moment from 'moment'
import * as R from 'ramda'

import { isExist } from '../../../utils/ramdaUtils'
import { emailRegex, youtubeIdRegex } from '../../../utils/validator'

const descriptionTextLimit = 600

export const getValidationRules = ({
  methods,
  isPublish,
  t,
  endMoment
}) => name => {
  const requiredDependingOnSave = message => ({
    required: {
      value: isPublish,
      message
    }
  })

  const validEmail = message => ({
    pattern: {
      value: emailRegex,
      message
    }
  })

  const validators = {
    title: {
      required: t('personalFundraising.create.form.title.required'),
      maxLength: {
        value: 32,
        message: t('personalFundraising.create.form.title.exceedMaxLength')
      }
    },
    contactEmail: {
      ...requiredDependingOnSave(
        t('personalFundraising.create.form.contactEmail.required')
      ),
      ...validEmail(t('personalFundraising.create.form.contactEmail.invalid')),
      validate: email => {
        const secondEmail = methods.getValues('contactEmailAgain')
        return (
          email === secondEmail ||
          t(
            'personalFundraising.create.form.contactEmail.repeatInputNotIdentical'
          )
        )
      }
    },
    contactEmailAgain: {
      ...requiredDependingOnSave(
        t('personalFundraising.create.form.contactEmailAgain.required')
      ),
      ...validEmail(
        t('personalFundraising.create.form.contactEmailAgain.invalid')
      ),
      validate: email => {
        const secondEmail = methods.getValues('contactEmail')
        return (
          email === secondEmail ||
          t(
            'personalFundraising.create.form.contactEmailAgain.repeatInputNotIdentical'
          )
        )
      }
    },
    donationTarget: {
      ...requiredDependingOnSave(
        t('personalFundraising.create.form.donationTarget.required')
      ),
      min: {
        value: 10,
        message: t('personalFundraising.create.form.donationTarget.outOfRange')
      },
      max: {
        value: 1000000,
        message: t('personalFundraising.create.form.donationTarget.outOfRange')
      }
    },
    endDate: {
      ...requiredDependingOnSave(
        t('personalFundraising.create.form.endDate.required')
      ),
      validate: dateValue => {
        if (!isPublish && !isExist(dateValue)) return true
        return (
          moment(dateValue, 'YYYY/MM/DD').isBetween(moment(), endMoment) ||
          t('personalFundraising.create.form.endDate.required')
        )
      }
    },
    endTime: {
      ...requiredDependingOnSave(
        t('personalFundraising.create.form.endTime.required')
      )
    },
    description: {
      ...requiredDependingOnSave(
        t('personalFundraising.create.form.description.required')
      ),
      maxLength: {
        value: descriptionTextLimit,
        message: t(
          'personalFundraising.create.form.description.exceedMaxLength'
        )
      }
    },
    donationItemsDraftSetting: {
      ...requiredDependingOnSave(
        t('personalFundraising.create.form.donationItemsDraftSetting.required')
      ),
      min: {
        value: 10,
        message: t(
          'personalFundraising.create.form.donationItemsDraftSetting.outOfRange'
        )
      },
      max: {
        value: 50000,
        message: t(
          'personalFundraising.create.form.donationItemsDraftSetting.outOfRange'
        )
      },
      validate: value => {
        if (!isPublish && !isExist(value)) return true
        const { donationItemsDraftSetting } = methods.getValues()
        return (
          R.pipe(
            R.reject(R.isEmpty),
            R.filter(R.equals(value)),
            R.length
          )(donationItemsDraftSetting) === 1 ||
          t(
            'personalFundraising.create.form.donationItemsDraftSetting.shouldBeUnique'
          )
        )
      }
    },
    titleImage: {
      validate: value =>
        R.isNil(value) ||
        R.pipe(R.prop('fileId'), R.complement(R.isNil))(value) ||
        t('personalFundraising.create.form.titleImage.failedUpload')
    },
    youtubeId: {
      validate: value =>
        R.isNil(value) ||
        R.isEmpty(value) ||
        R.test(youtubeIdRegex, value) ||
        t('personalFundraising.create.form.youtubeId.invalid')
    },
    relatedImages: {
      validate: value =>
        R.isEmpty(value) ||
        R.pipe(R.pluck('fileId'), R.all(R.complement(R.isNil)))(value) ||
        t('personalFundraising.create.form.relatedImages.failedUpload')
    },
    corporateCreatorName: {
      required: {
        value: isPublish && methods.getValues('useCorporateCreator'),
        message: t(
          'personalFundraising.create.form.corporateCreator.name.required'
        )
      },
      maxLength: {
        value: 200,
        message: t(
          'personalFundraising.create.form.corporateCreator.name.exceedMaxLength'
        )
      }
    },
    corporateCreatorLogoImage: {
      required: {
        value: isPublish && methods.getValues('useCorporateCreator'),
        message: t(
          'personalFundraising.create.form.corporateCreator.logoImage.required'
        )
      },
      validate: value =>
        R.isNil(value) ||
        R.pipe(R.prop('fileId'), R.complement(R.isNil))(value) ||
        t(
          'personalFundraising.create.form.corporateCreator.logoImage.failedUpload'
        )
    },
    corporateCreatorBR: {
      validate: value =>
        R.isNil(value) ||
        R.pipe(R.prop('fileId'), R.complement(R.isNil))(value) ||
        t('personalFundraising.create.form.corporateCreator.BR.failedUpload')
    }
  }
  return validators[name]
}
